import { render } from "./craBarChart.vue?vue&type=template&id=437c3235&scoped=true"
import script from "./craBarChart.vue?vue&type=script&lang=js"
export * from "./craBarChart.vue?vue&type=script&lang=js"

import "./craBarChart.vue?vue&type=style&index=0&id=437c3235&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437c3235"]])

export default __exports__